<template>
    <b-card
        :title="channel.name.toUpperCase()"
        :loading="loading || !actionsReady"
        :error-message="errorMessage"
        :disabled="!formValid || !actionsReady"
        :class="[channel.system == 'mail' && 'full-card']"
        @cancel="closeDialog"
        @submit="submitDialog"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <div v-if="channel.system == 'mail'">
            <v-row class=" pa-0 ma-0" style="border: none !important;">
                <v-col
                    cols="12"
                    md="12"
                    style=""
                    class="pb-0 mb-0 header-field-container pl-8"
                >
                    <b-mentionable :mentionable-items="mentionableItems">
                        <b-text-field
                            :class="[
                                error.subject && 'has-error',
                                'header-field'
                            ]"
                            v-model="channel.subject"
                            :label="translations.channelSubject[lang]"
                            :success="success.subject"
                            :error-messages="error.subject"
                            @focus="error.subject = ''"
                            @blur="validateSubject"
                        />
                    </b-mentionable>
                </v-col>
                <v-col cols="12" md="12" class="pa-0 ma-0">
                    <b-email-editor
                        @update="updateMailData"
                        :design="channel.design"
                        :reset-thumbnail="resetThumbnail"
                    />
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <b-mentionable
                v-if="!['sms', 'viber'].includes(channel.system)"
                :mentionable-items="mentionableItems"
            >
                <b-text-field
                    class="ma-1 ml-0"
                    v-model="channel.title[channelLang]"
                    :label="translations.channelTitleModal[lang]"
                    :success="success.title"
                    :error-messages="error.title"
                    @focus="error.title = ''"
                    @blur="validateTitle"
                >
                    <template v-slot:append>
                        <b-lang-menu
                            v-model="channelLang"
                            type="inner"
                        ></b-lang-menu>
                    </template>
                </b-text-field>
            </b-mentionable>
            <b-mentionable :mentionable-items="mentionableItems">
                <b-textarea
                    v-model="channel.body[bodyLang]"
                    class="ma-1 ml-0"
                    color="secondary"
                    validate-on-blur
                    dense
                    clearable
                    hide-details="auto"
                    outlined
                    :isSms="channel.system == 'sms'"
                    :label="translations.channelBodyModal[lang]"
                    :success="success.body"
                    :error-messages="error.body"
                    @focus="error.body = ''"
                    @blur="validateBody"
                >
                    <template v-slot:append>
                        <b-lang-menu
                            v-model="bodyLang"
                            type="inner"
                        ></b-lang-menu>
                    </template>
                </b-textarea>
            </b-mentionable>
            <v-col v-if="!['sms', 'viber'].includes(channel.system)">
                <v-checkbox
                    v-model="channel.has_image"
                    color="secondary"
                    class="mt-0 pt-0"
                    hide-details="auto"
                >
                    <template v-slot:label>
                        <h4 class="secondary--text">
                            {{ translations.imageDisplayText[lang] }}
                        </h4>
                    </template>
                </v-checkbox>
                {{
                    channel.image &&
                        channel.image.length &&
                        channel.image.substr(0, 33)
                }}
                <v-card v-if="channel.has_image" outlined class="mt-3">
                    <v-card-title class="subtitle-1 font-weight-medium pb-0">
                        {{ translations.imageOptional[lang] }} </v-card-title
                    >{{ channel.image && channel.image.length }}
                    <v-row
                        no-gutters
                        justify="space-between"
                        class="pa-5 flex-column"
                    >
                        <v-col cols="12">
                            <v-img :src="image[channel.system]"></v-img>
                        </v-col>
                        <v-col cols="21" class="mr-3 mt-2">
                            <v-file-input
                                color="secondary"
                                outlined
                                dense
                                prepend-icon="mdi-file-image"
                                @change="onFileSelected"
                                v-model="channel.image_file"
                                @focus="
                                    () => {
                                        error.image = '';
                                        success.image = false;
                                    }
                                "
                                @blur="validateImage"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col
                v-if="!['sms', 'viber'].includes(channel.system)"
                class="pt-0"
            >
                <b-textarea
                    v-model="channel.link"
                    :prepend-inner-icon="icons.mdiLink"
                    rows="2"
                    :label="translations.channelURLModal[lang]"
                    :success="success.link"
                    :error-messages="error.link"
                    @focus="error.link = ''"
                    @blur="validateLink"
                >
                </b-textarea>
            </v-col>

            <v-col v-if="channel.system == 'viber'" class="pt-0">
                <b-text-field
                    v-model="channel.validity_period"
                    :prepend-inner-icon="icons.mdiClockOutline"
                    :label="translations.validityPeriod[lang]"
                    :success="success.validityPeriod"
                    :error-messages="error.validityPeriod"
                    @focus="error.validityPeriod = ''"
                    @blur="validateValidityPeriod"
                >
                </b-text-field>

                <v-checkbox
                    v-model="channel.promotional"
                    color="secondary"
                    class="mt-3 pt-0"
                    hide-details="auto"
                >
                    <template v-slot:label>
                        <h4 class="secondary--text">
                            {{ translations.promotional[lang] }}
                        </h4>
                    </template>
                </v-checkbox>
                <v-col v-if="channel.promotional" outlined class="pr-0">
                    <v-row
                        v-if="image[channel.system]"
                        no-gutters
                        justify="space-between"
                        class="pa-0 flex-column"
                        :class="[image[channel.system] && 'pt-2 pb-5']"
                    >
                        <v-col cols="12">
                            <v-img :src="image[channel.system]"></v-img>
                        </v-col>
                    </v-row>
                    <v-file-input
                        color="secondary"
                        outlined
                        dense
                        :label="translations.image[lang]"
                        prepend-inner-icon="mdi-file-image"
                        :prepend-icon="''"
                        :success="success.image"
                        :error-messages="error.image"
                        v-model="channel.image_file"
                        @focus="
                            () => {
                                error.image = '';
                                success.image = false;
                            }
                        "
                        @blur="validateImage"
                        @change="onFileSelected"
                        class="mb-1"
                    >
                    </v-file-input>
                    <b-text-field
                        v-model="channel.button[channelLang]"
                        :label="translations.channelButton[lang]"
                        :success="success.button"
                        :error-messages="error.button"
                        @focus="error.button = ''"
                        @blur="validateButton"
                        class="mt-n1"
                    >
                        <template v-slot:append>
                            <b-lang-menu
                                v-model="promoLang"
                                type="inner"
                            ></b-lang-menu>
                        </template>
                    </b-text-field>

                    <b-textarea
                        v-if="channel.system != 'sms'"
                        v-model="channel.button_url"
                        :prepend-inner-icon="icons.mdiLink"
                        rows="2"
                        :label="translations.channelButtonURL[lang]"
                        :success="success.buttonUrl"
                        :error-messages="error.buttonUrl"
                        @focus="error.buttonUrl = ''"
                        @blur="validateButtonUrl"
                    >
                    </b-textarea>
                </v-col>

                <v-checkbox
                    v-model="channel.fallback"
                    color="secondary"
                    class="mt-3 pt-0"
                    hide-details="auto"
                >
                    <template v-slot:label>
                        <h4 class="secondary--text">
                            {{ translations.fallback[lang] }}
                        </h4>
                    </template>
                </v-checkbox>
                <v-col v-if="channel.fallback" outlined class="pr-0">
                    <b-mentionable :mentionable-items="mentionableItems">
                        <b-textarea
                            v-model="channel.sms[bodyLang]"
                            isSms
                            :label="translations.fallbackContent[lang]"
                            :success="success.fallback"
                            :error-messages="error.fallback"
                            @focus="error.fallback = ''"
                            @blur="validateFallback"
                        >
                            <template v-slot:append>
                                <b-lang-menu
                                    v-model="fallbackLang"
                                    type="inner"
                                ></b-lang-menu>
                            </template>
                        </b-textarea>
                    </b-mentionable>
                </v-col>
            </v-col>
        </div>

        <div class="footer-options">
            <v-expansion-panels
                focusable
                accordion
                flat
                hover
                tile
                :disabled="!formValid"
                v-model="testPanel"
                class="test-panel transition-all"
            >
                <v-expansion-panel>
                    <v-expansion-panel-header ripple class="pt-2 pb-2 rounded">
                        Test
                        <template v-slot:actions>
                            <v-icon color="secondary">
                                $expand
                            </v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <b-card
                            hide-title
                            hide-default-footer
                            :cancel-btn="false"
                            elevation="0"
                            :submit-text="{
                                el: 'Αποστολή',
                                en: 'Send',
                                it: 'Invia'
                            }"
                            @cancel="testDialog = false"
                        >
                            <div
                                class="subtitle-1 font-weight-medium py-3"
                                style="min-width: 250px; margin-left: -16px;"
                            >
                                <b-text-field
                                    v-model="testContact[channel.system]"
                                    :label="
                                        channel.system == 'mail'
                                            ? 'Email'
                                            : translations.mobileInputLabel[
                                                  lang
                                              ]
                                    "
                                    no-margin-top
                                ></b-text-field>
                            </div>
                            <v-card-actions class="d-flex justify-center">
                                <v-btn
                                    type="submit"
                                    color="secondary"
                                    class="text-capitalize px-5"
                                    style="font-size: 0.9rem"
                                    depressed
                                    @click="
                                        submitTestMessage({
                                            [channel.system]: campaignChannel,
                                            [channel.system == 'mail'
                                                ? 'email_address'
                                                : 'mobile']: testContact[
                                                channel.system
                                            ],
                                            type: channel.system
                                        });
                                        testDialog = false;
                                    "
                                    :loading="loading"
                                    >{{
                                        {
                                            el: "Αποστολή",
                                            en: "Send",
                                            it: "Invia"
                                        }[lang]
                                    }}
                                </v-btn>
                            </v-card-actions>
                        </b-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <div class="footer-select-container d-flex justify-center">
                <v-autocomplete
                    v-if="channel.system == 'mail'"
                    class="footer-select"
                    :items="emailThemes"
                    v-model="selectedTheme"
                    item-text="title"
                    item-value="store_email_theme_id"
                    menu-props="offsetY"
                    :label="translations.emailThemes[lang]"
                    outlined
                    dense
                    hide-details
                    clearable
                    color="secondary"
                    :search-input.sync="themeSearch"
                    :loading="loading || !themeIsReady"
                    :disabled="!themeIsReady"
                    :disable-lookup="true"
                    return-object
                >
                    <template v-slot:item="data">
                        <v-col
                            class="d-flex flex-column justify-center align-center pa-2"
                        >
                            <v-img
                                contain
                                height="200"
                                width="280"
                                tile
                                :src="data.item.thumbnail"
                            >
                                <!-- <img :src="data.item.thumbnail"> -->
                            </v-img>
                            <v-list-item-content>
                                <v-list-item-title
                                    v-html="data.item.title"
                                ></v-list-item-title>
                            </v-list-item-content>
                        </v-col>
                    </template>
                    <template v-slot:append-item>
                        <div v-intersect="endIntersectThemes"></div>
                        <v-list-item v-if="loading">
                            <v-list-item-action class="ml-1">
                                <v-row class="d-flex align-center">
                                    <v-btn
                                        class="text-capitalize"
                                        depressed
                                        fab
                                        small
                                        :loading="true"
                                        style="background: transparent"
                                    >
                                    </v-btn>
                                    <span class="pa-2">{{
                                        translations.loadMore[lang]
                                    }}</span>
                                </v-row>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                    <template v-slot:append>
                        <v-btn
                            v-if="!themeIsReady"
                            elevation="0"
                            :loading="!themeIsReady || true"
                            color="#ffffff00"
                            class="pa-0 mt-n2 ml-n2"
                            max-width="30px"
                            min-width="30px"
                        ></v-btn>
                    </template>
                </v-autocomplete>
            </div>
        </div>
    </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import { mdiLink, mdiClockOutline } from "@mdi/js";
import validators from "@/utils/validators/loyaltyPanel/channel";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";
import defaultThumbnail from "@/assets/thumbnail.svg";
import { sleepUntil } from "@/utils/helpers";
import { isEqual } from "lodash";

export default {
    name: "ChannelForm",

    props: {
        channel: Object,
        isOpen: Boolean,
        emailAction: {
            type: String,
            default: "create"
        }
    },

    mixins: [validators, translations, defaultThumbnail],

    data() {
        return {
            icons: {
                mdiLink,
                mdiClockOutline
            },
            channelLang: this.$route.params.lang,
            fallbackLang: this.$route.params.lang,
            promoLang: this.$route.params.lang,
            changeTitleElAuto: true,
            changeTitleItAuto: true,
            changeTitleEnAuto: true,
            bodyLang: this.$route.params.lang,
            changeBodyElAuto: true,
            changeBodyItAuto: true,
            changeBodyEnAuto: true,
            // hasValidPeriod: false,
            changeButtonElAuto: true,
            changeButtonItAuto: true,
            changeButtonEnAuto: true,
            changeFallbackElAuto: true,
            changeFallbackItAuto: true,
            changeFallbackEnAuto: true,
            imageFile: null,
            image: {},
            imageReader: null,
            testPanel: null,
            testContact: {
                mail: "",
                sms: "",
                push: ""
            },
            selectedTheme: {},
            themeSearch: "",
            themesPage: 1,
            defaultThumbnail,
            emailThumbnail: null,
            themeIsReady: false,
            currentDesign: {},
            resetThumbnail: false
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation"
        ]),
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "notificationVariables"
        ]),

        ...mapState("loyaltyPanel/campaigns/emailThemes", [
            "emailThemes",
            "newEmailTheme",
            "theme"
        ]),
        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        },
        themesPagination: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.emailThemes
                    .pagination;
            }
        },
        lang() {
            return this.$route.params.lang;
        },
        mentionableItems() {
            return this.notificationVariables.map(e => ({
                value: e,
                label: this.translations[e]?.lang || e
            }));
        },
        actionsReady() {
            return this.channel.system != "mail" || this.themeIsReady;
        },

        showImageUpload: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .uploadingImage;
            },

            set(val) {
                this.setUploadingImage(val);
            }
        },
        showTest() {
            return this.formValid;
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
        campaignChannel() {
            if (this.channel.system == "sms") {
                return { ...this.channel.body };
            }
            return {
                ...this.channel,
                icon: undefined,
                active: undefined,
                priority: undefined,
                system: undefined,
                name: undefined
            };
        },
        uploadedImage() {
            return this.channel?.image || "";
        },
        themesQuery() {
            let query = "?";
            let params = {
                page: this.themesPage,
                q: this.themeSearch
            };

            for (let key in params) {
                if (params[key]) {
                    query += `${key}=${params[key]}&`;
                }
            }

            return query.slice(0, query.length - 1);
        },

        emailTheme() {
            return {
                title: this.channel.subject,
                theme: this.channel.design,
                thumbnail: `https://roadcube.com/${defaultThumbnail}`
            };
        }
    },

    methods: {
        ...mapMutations(["setNotification", "setLoading"]),
        ...mapMutations([
            "setResetSuccess",
            "setResetValidation",
            "setNotification"
        ]),
        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setUploadingImage",
            "setCanGoToNextStep"
        ]),
        ...mapMutations("loyaltyPanel/campaigns/emailThemes", [
            "setEmailThemes"
        ]),

        ...mapActions("loyaltyPanel/campaigns/newCampaign", [
            "sendTestMessage",
            "uploadImage"
        ]),
        ...mapActions("loyaltyPanel/campaigns/emailThemes", [
            "getEmailThemes",
            "createTheme",
            "uploadThumbnail"
        ]),
        async updateMailData(val) {
            if (this.channel.system == "mail") {
                this.themeIsReady = false;
                if (val?.html) {
                    this.channel.body = val.html;
                }
                this.currentDesign = val.design;
                this.emailThumbnail = val.thumbnail || null;
                this.themeIsReady = val.isReady;
                this.resetThumbnail = false;
                this.validateBody();
            }
        },

        async onFileSelected(event) {
            if (event) {
                this.channel.has_image = false;
                this.$set(this.image, this.channel.system, undefined);
                this.channel.image_file = event;
                let url = await this.uploadImage({
                    image: this.channel.image_file,
                    type: this.channel.system
                });
                if (url) {
                    this.channel.has_image = true;
                    const imageReader = new FileReader();
                    imageReader.readAsDataURL(this.channel.image_file);
                    imageReader.onload = async e => {
                        this.$set(
                            this.image,
                            this.channel.system,
                            e.target.result
                        );
                    };
                } else {
                    this.$set(this.image, this.channel.system, null);
                }
            }
            await this.validateImage();
        },

        closeDialog() {
            this.testPanel = null;
            this.testContact[this.channel.system] = "";
            this.$emit("cancel");
        },

        async getThumbnail() {
            if (this.emailThumbnail?.blob) {
                let thumbnailResponse = await this.uploadThumbnail({
                    image: this.emailThumbnail?.blob
                });
                this.emailTheme.thumbnail = thumbnailResponse?.url || "";
            } else {
                this.emailTheme.thumbnail = "";
            }
        },

        async prepareTheme() {
            try {
                this.themeIsReady = false;
                this.resetThumbnail = true;
                this.channel.design = null;
                this.channel.design = this.currentDesign;
                await sleepUntil(() => this.themeIsReady, 30000);
                return;
            } catch (error) {
                console.log("prepare theme error: " + error);
            }
        },

        async submitTheme(action) {
            try {
                this.setLoading(true);

                await this.prepareTheme();
                await sleepUntil(() => this.themeIsReady, 300000);
                await this.getThumbnail();
                await sleepUntil(() => this.themeIsReady, 300000);
                let res = await this[`${action}Theme`](this.emailTheme);
                if (res?.data?.theme) {
                    this.resetThumbnail = false;
                }
                this.setLoading(false);
            } catch (error) {
                console.log("submit theme error: " + error);
            }
        },

        async submitDialog() {
            this.channel.valid = this.formValid;
            if (this.channel.valid) {
                if (this.channel.system == "mail") {
                    await this.submitTheme(this.emailAction);
                }

                this.$emit("rise");
                this.closeDialog();
            }
        },

        async submitTestMessage(payload) {
            if (this.channel.system == "mail") {
                this.setLoading(true);
                await this.prepareTheme();
                await sleepUntil(() => this.themeIsReady, 300000);
                this.setLoading(false);
            }
            let res = await this.sendTestMessage(payload);
            if (res && res.data && !res.data.error) {
                this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations.testSent[this.lang]
                });
            } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: this.translations.testFailed[this.lang]
                });
            }
        },

        endIntersectThemes(entries, observer, isIntersecting) {
            if (
                isIntersecting &&
                this.emailThemes &&
                this.emailThemes.length < this.themesPagination.total
            ) {
                this.loadMoreThemes();
            }
        },

        async loadMoreThemes() {
            let prevThemes = [...this.emailThemes];
            this.themesPage++;
            const body = {
                query: this.themesQuery,
                page: this.page
            };
            await this.getEmailThemes(body);
            this.setEmailThemes([...prevThemes, ...this.emailThemes]);
        }
    },

    watch: {
        ["$route.params.lang"](val) {
            this.channelLang = val;
            this.bodyLang = val;
        },
        formValid(val) {
            if (!val) this.setCanGoToNextStep(false);
        },
        ["channel.title"]: {
            handler(val) {
                if (val) {
                    let langCapital =
                        this.channelLang[0].toUpperCase() + this.channelLang[1];
                    if (this.lang == this.channelLang) {
                        if (
                            this.channelLang != "el" &&
                            this.changeTitleElAuto &&
                            this.channel.title.el !=
                                this.channel.title[this.channelLang]
                        ) {
                            this.channel.title.el = this.channel.title[
                                this.channelLang
                            ];
                        }

                        if (
                            this.channelLang != "it" &&
                            this.changeTitleItAuto &&
                            this.channel.title.it !=
                                this.channel.title[this.channelLang]
                        ) {
                            this.channel.title.it = this.channel.title[
                                this.channelLang
                            ];
                        }

                        if (
                            this.channelLang != "en" &&
                            this.changeTitleEnAuto &&
                            this.channel.title.en !=
                                this.channel.title[this.channelLang]
                        ) {
                            this.channel.title.en = this.channel.title[
                                this.channelLang
                            ];
                        }

                        this[`changeTitle${langCapital}Auto`] = false;
                    } else if (
                        val[this.channelLang] != this.channel.title[this.lang]
                    ) {
                        this[`changeTitle${langCapital}Auto`] = false;
                    }
                }
            },
            deep: true
        },

        ["channel.body.en"](val) {
            if (this.lang == "en") {
                if (this.changeBodyElAuto) {
                    this.channel.body.el = val;
                }

                if (this.changeBodyItAuto) {
                    this.channel.body.it = val;
                }

                this.changeBodyEnAuto = false;
            } else if (val != this.channel.body[this.lang]) {
                this.changeBodyEnAuto = false;
            }
        },

        ["channel.body.el"](val) {
            if (this.lang == "el") {
                if (this.changeBodyEnAuto) {
                    this.channel.body.en = val;
                }

                if (this.changeBodyItAuto) {
                    this.channel.body.it = val;
                }

                this.changeBodyElAuto = false;
            } else if (val != this.channel.body[this.lang]) {
                this.changeBodyElAuto = false;
            }
        },

        ["channel.body.it"](val) {
            if (this.lang == "it") {
                if (this.changeBodyElAuto) {
                    this.channel.body.el = val;
                }

                if (this.changeBodyEnAuto) {
                    this.channel.body.en = val;
                }

                this.changeBodyItAuto = false;
            } else if (val != this.channel.body[this.lang]) {
                this.changeBodyItAuto = false;
            }
        },

        ["channel.button"]: {
            handler(val) {
                if (val) {
                    let langCapital =
                        this.channelLang[0].toUpperCase() + this.channelLang[1];
                    if (this.lang == this.channelLang) {
                        if (
                            this.channelLang != "el" &&
                            this.changeButtonElAuto &&
                            this.channel.button.el !=
                                this.channel.button[this.channelLang]
                        ) {
                            this.channel.button.el = this.channel.button[
                                this.channelLang
                            ];
                        }

                        if (
                            this.channelLang != "it" &&
                            this.changeButtonItAuto &&
                            this.channel.button.it !=
                                this.channel.button[this.channelLang]
                        ) {
                            this.channel.button.it = this.channel.button[
                                this.channelLang
                            ];
                        }

                        if (
                            this.channelLang != "en" &&
                            this.changeButtonEnAuto &&
                            this.channel.button.en !=
                                this.channel.button[this.channelLang]
                        ) {
                            this.channel.button.en = this.channel.button[
                                this.channelLang
                            ];
                        }

                        this[`changeButton${langCapital}Auto`] = false;
                    } else if (
                        val[this.channelLang] != this.channel.button[this.lang]
                    ) {
                        this[`changeButton${langCapital}Auto`] = false;
                    }
                }
            },
            deep: true
        },

        ["channel.sms"]: {
            handler(val) {
                if (val) {
                    let langCapital =
                        this.channelLang[0].toUpperCase() + this.channelLang[1];
                    if (this.lang == this.channelLang) {
                        if (
                            this.channelLang != "el" &&
                            this.changeFallbackElAuto &&
                            this.channel.sms.el !=
                                this.channel.sms[this.channelLang]
                        ) {
                            this.channel.sms.el = this.channel.sms[
                                this.channelLang
                            ];
                        }

                        if (
                            this.channelLang != "it" &&
                            this.changeFallbackItAuto &&
                            this.channel.sms.it !=
                                this.channel.sms[this.channelLang]
                        ) {
                            this.channel.sms.it = this.channel.sms[
                                this.channelLang
                            ];
                        }

                        if (
                            this.channelLang != "en" &&
                            this.changeFallbackEnAuto &&
                            this.channel.sms.en !=
                                this.channel.sms[this.channelLang]
                        ) {
                            this.channel.sms.en = this.channel.sms[
                                this.channelLang
                            ];
                        }

                        this[`changeFallback${langCapital}Auto`] = false;
                    } else if (
                        val[this.channelLang] != this.channel.sms[this.lang]
                    ) {
                        this[`changeFallback${langCapital}Auto`] = false;
                    }
                }
            },
            deep: true
        },

        ["channel.promotional"](val) {
            if (!val) {
                this.channel.button_url = "";
                this.channel.button = this.channel.button || {};
                this.channel.button.el = "";
                this.channel.button.en = "";
                this.channel.button.it = "";
            }
        },

        ["channel.fallback"](val) {
            if (!val) {
                this.channel.sms = this.channel.sms || {};
                this.channel.sms.el = "";
                this.channel.sms.en = "";
                this.channel.sms.it = "";
            }
        },

        ["channel.image_file"]: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.$set(this.image, this.channel.system, undefined);
                }
            },
            deep: true
        },

        ["selectedTheme.theme"]: {
            // immediate: true,
            handler(val) {
                if (val) {
                    // console.log('selectedTheme.theme', val)
                    this.channel.design = val;
                }
            },
            deep: true
        },

        ["channel.design"]: {
            // immediate: true,
            handler(val) {
                if (val) {
                    console.log("channel.design", val);
                    // this.channel.design = val;
                }
            },
            deep: true
        },

        ["currentDesign"]: {
            // immediate: true,
            handler(val, preVal) {
                // if (!val) {
                console.log("currentDesign", val);
                // this.channel.design = val;
                // }
            },
            deep: true
        }
    },

    mounted() {
        this.getEmailThemes({ query: this.themesQuery });
    },

    beforeDestroy() {
        console.log("beforeUnmount", this.isOpen, this.currentDesign);
        this.channel.design = this.currentDesign;
    }
};
</script>
<style>
.test-panel {
    width: 280px;
    position: relative;
    bottom: 6px;
    left: 6px;
}
.test-panel .v-expansion-panel-header {
    min-height: 38px;
}

.invisible {
    opacity: 0;
}

.transition-all {
    transition: all 0.5s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 2s,
        background-color 2s;
}
.header-field-container {
    position: absolute;
    top: 0;
    padding-top: 0;
    left: 60px;
    overflow: hidden;
    max-width: 1050px;
}
.header-field {
    padding-right: 0 !important;
}
.has-error .error--text {
    background: white !important;
    padding-left: 5px;
    padding-bottom: 3px;
    border-radius: 4px;
}
.full-card {
    margin: 0 !important;
    padding: 0 !important;
}
.full-card .v-card__text {
    margin: 0 !important;
    padding: 0 !important;
}
.footer-select {
    max-width: 320px;
    position: relative;
}

.footer-select-container {
    width: 100%;
    position: absolute;
    bottom: 6px;
    left: 0;
}

.footer-options {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: end;
    min-width: 100%;
    height: 0;
}
</style>
